<template>
    <footer class="shadow-sm mt-3 pt-3 pt-sm-5 px-3 px-sm-5">
        <div class="container">
            <div class="row">
                <div class="row">
                    <div class="col-3">
                        <ul class="list-unstyled">
                            <li>
                                <a href="" :title="translate('header.home')">{{ translate('header.home') }}</a>
                            </li>
                            <li>
                                <a href="/contact" :title="translate('footer.contact_us')">{{ translate('footer.contact_us') }}</a>
                            </li>
                            <li>
                                <a href="/sitemap" :title="translate('footer.sitemap')">{{ translate('footer.sitemap') }}</a>
                            </li>
                            <li>
                                <a href="/terms" :title="translate('footer.terms_privacy')">{{ translate('footer.terms_privacy') }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-3">
                        <ul class="list-unstyled">
                            <li>
                                <a href="/login" :title="translate('header.login')">{{ translate('header.login') }}</a>
                            </li>
                            <li>
                                <a href="/login" :title="translate('header.register')">{{ translate('header.register') }}</a>
                            </li>
                            <li>
                                <a href="/forget" :title="translate('footer.forgot_password')">{{ translate('footer.forgot_password') }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-3">
                        <ul class="list-unstyled">
                            <li>
                                <a href="" target="_blank" title="Facebook"><i class="fab fa-facebook-square"></i> Facebook</a>
                            </li>
                            <li>
                                <a href="" target="_blank" title="Twitter"><i class="fab fa-twitter"></i> Twitter</a>
                            </li>

                            <li>
                                <a href="" target="_blank" title="Instagram"><i class="fab fa-instagram"></i> Instagram</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-3">
                        <ul class="list-unstyled">
                            <li v-for="locale in locales" :key="locale">
                                <a href="#" style="text-transform: uppercase;" @click="changeLocale(locale)">{{ locale }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-xs-5">
                        <p class="text-center">{{ translate('footer.terms_of_service') }}</p>
                    </div>
                </div>
                <div class="w-100">
                    <div>
                        <p class="text-center">
                            {{ translate('footer.copyright') }} {{ year }} <a href="" target="_blank"> APP_NAME </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import { LOCALES } from '@/constants/locales';
export default {
    name: 'Footer',
    data () {
        return {
            year: new Date().getFullYear(),
            locales: LOCALES
        }
    },
    methods: {
        changeLocale(locale) {
            if (this.$i18n.locale !== locale) {
                this.$i18n.locale = locale;
                localStorage.setItem('locale', locale);
            }
        }
    }
}
</script>

<style scoped lang="scss">
    footer {
        background-color: #ff9a22;
        color: #fff;

        a {
            color: #fff;
        }
    }
</style>
